<template>
    <b-alert
        :class="alertClass"
        :variant="propVariant"
        dismissible
        :show="propShow"

        @dismissed="propShow=0"
        @dismiss-count-down="countDownChanged">

        <!-- Show countdown -->
        <!--<div>{{propMessage}} {{ dismissCountDown }}</div>-->

        <div>{{propMessage}}</div>
        <div class="ml-3" style="padding-bottom:15px !important;  border-radius: 50%; border: 2px solid; height: 25px; width: 25px;">
            <label style="color: inherit">
                {{dismissCountDown}}
            </label>
        </div>
        <a @click="closeMe()"><i class="fas fa-times"></i></a>
    </b-alert>
</template>

<script>
    export default {
        name: "Alert",
        data() {
            return {
                isShow: this.propShow,
                dismissSecs: 5,
                dismissCountDown: 0,
            }
        },
        created() {
            this.dismissCountDown = this.dismissSecs;
        },
        methods: {
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown;
                if (this.dismissCountDown <= 0) {
                    this.dismissCountDown = this.dismissSecs;
                    this.closeMe();
                }
            },
            closeMe: function() {
                this.$emit("onClose", false)
            },
        },
        computed: {
            alertClass: function () {
                var myClass = 'myAlert ';
                myClass += this.propVariant;
                return myClass;
            }
        },
        props: {
            propMessage: String,
            propShow: {
                type: Number,
                default: 0
            },
            propVariant: {
                type: String,
                default: 'primary'
            }
        },
    }
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/myAlert.vue